/**
 * VAL-ACTOR-JOURNEY-1-SIGNER slice C, R4 — split out of ValuationIntake.tsx
 * under docs/FILE_SIZE_POLICY.md. Visible whenever `fields` is non-empty;
 * each item scrolls to its field.
 * VAL-PATH-ADJUST P4b — an item with `href` is a link to the step that owns
 * the field instead (the legs and rates live on Adjustments and rates).
 */
import { Link } from 'react-router-dom'

export interface MissingField {
  id: string
  label: string
  href?: string
}

export function IntakeMissingFields({ fields }: { fields: MissingField[] }) {
  if (fields.length === 0) return null

  function scrollToField(id: string) {
    const el = document.getElementById(id)
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    el?.focus()
  }

  return (
    <div className="rounded-lg border border-pal-warning-border bg-pal-warning-bg p-4 text-sm text-pal-pill-warning-text">
      <p className="font-medium">Before you can run this valuation, fill in:</p>
      <ul className="mt-2 list-inside list-disc space-y-1">
        {fields.map(f => (
          <li key={f.id}>
            {f.href ? (
              <Link to={f.href} className="underline underline-offset-2 hover:text-amber-700">{f.label}</Link>
            ) : (
            <button
              type="button"
              onClick={() => scrollToField(f.id)}
              className="underline underline-offset-2 hover:text-amber-700"
            >
              {f.label}
            </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
